'use client';
interface LinesProps {
	fill?: string;
	className?: string;
	size: number;
}
export function Lines(props: LinesProps) {
	return (
		<svg
			className={props.className}
			width={`${props.size}`}
			viewBox="0 0 190 10"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect x="110" width="80" height="10" rx="5" fill={props.fill ?? '#282828'} />
			<rect width="60" height="10" rx="5" fill={props.fill ?? '#282828'} />
			<rect x="70" width="30" height="10" rx="5" fill={props.fill ?? '#282828'} />
		</svg>
	);
}
